import { makeStyles } from '@mui/styles';
import Grid from 'apollo-react/components/Grid';
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import * as selectors from './selectors';
import Loader from '../../../components/CustomLoader';
import TaskStatusCard from '../../../components/TaskStatusCard';
import { useWindowDimensions } from '../../../custom-hooks/useWindowDimensions';

const useStyles = makeStyles({
  root: {
    paddingBottom: ({ isMobileDevice }) => (isMobileDevice ? 8 : 0),
  },
});

const TaskStatus = ({ loading, tasks }) => {
  const { isMobileDevice } = useWindowDimensions();
  const classes = useStyles({ isMobileDevice });

  if (loading) {
    return <Loader />;
  }

  return (
    <Grid className={classes.root} container spacing={1} ui-ta="TaskStatus">
      {tasks.map((task) => (
        <Grid key={task.id} item xs={12} ui-ta="TaskStatusContainer">
          <TaskStatusCard
            isInitialTask={task.isInitialTask}
            isTaskPortal={task.isTaskPortal}
            label={task.label}
            date={task.date}
            user={task.user}
            status={task.status}
            completedSubtasksCount={task.completedSubtasksCount}
            totalSubtasksCount={task.totalSubtasksCount}
            remainingDays={task.remainingDays}
            overdueDays={task.overdueDays}
          />
        </Grid>
      ))}
    </Grid>
  );
};

const mapStateToProps = createStructuredSelector({
  loading: selectors.getLoading,
  tasks: selectors.getTasks,
});

const EnhancedComponent = connect(mapStateToProps)(TaskStatus);

export default EnhancedComponent;
